import React, { useState } from "react";
import { FilterOutlined } from "@ant-design/icons";
import {
    Button, Switch, Popover
} from "antd";
import { getWhiteLabelDictionary } from "../../utils/whitelabel/WhiteLabel.Helper";

const ColumnFilter = function ({
    columns,
    group,
    onChange,
    hidden = [],
    disabled,
    size,
    label = "Column Filter",
    buttonProps = {}
}) {
    const [visible, setvisible] = useState(false);
    const getContent = () => (
        <div
            className="column--filter--container"
            style={{
                height: "100%",
                width: "100%",
                maxHeight: "70mm",
                overflowY: "auto"
            }}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            {columns.map((col) => {
                const {
                    key, title, hide, type = "column", color
                } = col;

                if (type === "value" && hidden.includes("behaviormatch")) {
                    return "";
                }
                return (
                    <div
                        className="d-flex align-items-center justify-content-between"
                        key={key}
                        style={{
                            padding: ".5mm"
                        }}
                    >
                        <div className="d-flex align-items-center gap-1">
                            {type === "value" && (
                                <span style={{
                                    width: "2mm", height: "2mm", borderRadius: "50%", backgroundColor: color
                                }}
                                />
                            )}
                            <span style={{ color }}>
                                {getWhiteLabelDictionary(key, title)}
                            </span>
                        </div>
                        <Switch
                            checked={(!hide && !hidden.includes(key))}
                            onChange={(e, e1) => {
                                e1.stopPropagation();
                                onChange({
                                    group,
                                    value: e,
                                    ...col
                                });
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
    return (
        <Popover
            content={(
                <>
                    <div
                        className="d-flex align-items-center justify-content-between"
                        style={{
                            padding: "1.5mm .5mm"
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <span>Columns</span>
                        <span>Show in table</span>
                    </div>
                    {getContent()}
                </>
            )}
            trigger="click"
            open={visible}
            placement="bottomRight"
            onOpenChange={(e) => {
                setvisible(e);
            }}
        >
            <Button
                size={size}
                disabled={disabled}
                // type={disabled ? "" : "secondary"}
                icon={<FilterOutlined />}
                onClick={(e) => {
                    e.stopPropagation();
                }}
                {...buttonProps}
            >
                {label}
            </Button>
        </Popover>
    );
};

export default ColumnFilter;
